import styled from '@emotion/styled';
import * as Text from '../../text';
import { Card } from '../base';

const Star = ({ onClick }: React.SVGProps<SVGElement>) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M21.5476 5.89615C22.3173 4.04567 22.7021 3.12042 23.2472 2.84309C23.7202 2.60243 24.2797 2.60243 24.7527 2.84309C25.2978 3.12042 25.6827 4.04567 26.4523 5.89616L29.7251 13.7648C29.9513 14.3088 30.0645 14.5809 30.2468 14.7875C30.4081 14.9702 30.6076 15.1151 30.8312 15.2121C31.0841 15.3216 31.3778 15.3452 31.9651 15.3923L40.46 16.0733C42.4577 16.2335 43.4566 16.3135 43.8888 16.7463C44.2638 17.1217 44.4367 17.6539 44.354 18.1781C44.2587 18.7822 43.4977 19.4341 41.9756 20.7379L35.5034 26.282C35.0559 26.6654 34.8321 26.8571 34.692 27.0943C34.5681 27.3042 34.4919 27.5387 34.4688 27.7813C34.4427 28.0556 34.5111 28.3422 34.6478 28.9154L36.6251 37.2049C37.0902 39.1544 37.3227 40.1291 37.0447 40.6739C36.8035 41.1466 36.3508 41.4755 35.8267 41.5588C35.2227 41.6548 34.3675 41.1325 32.6572 40.0878L25.3844 35.6456C24.8815 35.3385 24.6301 35.1849 24.3611 35.125C24.1233 35.0719 23.8767 35.0719 23.6388 35.125C23.3699 35.1849 23.1184 35.3385 22.6155 35.6456L15.3428 40.0878C13.6324 41.1325 12.7772 41.6548 12.1732 41.5588C11.6491 41.4755 11.1964 41.1466 10.9552 40.6739C10.6773 40.1291 10.9098 39.1544 11.3748 37.2049L13.3522 28.9154C13.4889 28.3422 13.5572 28.0556 13.5312 27.7813C13.5081 27.5387 13.4319 27.3042 13.3079 27.0943C13.1678 26.8571 12.944 26.6654 12.4965 26.282L6.02435 20.7379C4.50227 19.4341 3.74124 18.7822 3.64592 18.1781C3.5632 17.6539 3.73611 17.1217 4.11115 16.7463C4.54335 16.3135 5.54223 16.2335 7.53999 16.0733L16.0348 15.3923C16.6222 15.3452 16.9159 15.3216 17.1687 15.2121C17.3923 15.1151 17.5918 14.9702 17.7531 14.7875C17.9355 14.5809 18.0486 14.3088 18.2749 13.7648L21.5476 5.89615Z"
        fill="var(--surface-container-high)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.8784 14.5328L24.6057 6.66422C24.353 6.05667 24.1604 5.59556 24 5.23756C23.8396 5.59556 23.647 6.05666 23.3943 6.66421L20.1215 14.5328C20.1062 14.5698 20.0902 14.6086 20.0736 14.6492C19.9049 15.0605 19.6662 15.6423 19.2526 16.111C18.897 16.5138 18.4571 16.8334 17.9641 17.0471C17.3905 17.2957 16.7634 17.3429 16.3201 17.3762C16.2764 17.3795 16.2345 17.3827 16.1946 17.3859L7.69981 18.0669C7.04391 18.1195 6.54586 18.1602 6.15581 18.2021C6.44672 18.4653 6.82574 18.7909 7.32547 19.219L13.7976 24.7631C13.828 24.7891 13.8601 24.8163 13.8935 24.8447C14.2325 25.1322 14.7121 25.539 15.03 26.0772C15.3033 26.5399 15.4713 27.057 15.5222 27.5919C15.5814 28.2142 15.4324 28.8253 15.3272 29.2572C15.3168 29.2997 15.3069 29.3405 15.2976 29.3795L13.3202 37.669C13.1675 38.309 13.0523 38.7953 12.9717 39.1792C13.3119 38.9838 13.7387 38.724 14.3003 38.381L21.573 33.9388C21.6072 33.918 21.6429 33.8959 21.6802 33.8729C22.0584 33.6393 22.5935 33.3089 23.2037 33.1729C23.7281 33.056 24.2719 33.056 24.7963 33.1729C25.4064 33.3089 25.9415 33.6393 26.3198 33.8729C26.357 33.8959 26.3928 33.918 26.4269 33.9388L33.6997 38.381C34.2612 38.724 34.6881 38.9838 35.0283 39.1792C34.9476 38.7953 34.8324 38.309 34.6797 37.669L32.7024 29.3795C32.6931 29.3405 32.6831 29.2997 32.6728 29.2571C32.5675 28.8252 32.4186 28.2142 32.4778 27.5919C32.5287 27.057 32.6967 26.5399 32.9699 26.0772C33.2878 25.539 33.7674 25.1322 34.1065 24.8447C34.1399 24.8163 34.1719 24.7891 34.2023 24.7631L40.6745 19.219C41.1742 18.7909 41.5532 18.4653 41.8441 18.2021C41.4541 18.1602 40.956 18.1195 40.3001 18.0669L31.8053 17.3859C31.7654 17.3827 31.7235 17.3795 31.6798 17.3762C31.2365 17.3429 30.6094 17.2957 30.0359 17.0471C29.5429 16.8334 29.103 16.5138 28.7474 16.111C28.3337 15.6423 28.0951 15.0605 27.9263 14.6492C27.9097 14.6086 27.8938 14.5698 27.8784 14.5328ZM23.2472 2.84309C22.7021 3.12042 22.3173 4.04567 21.5476 5.89615L18.2749 13.7648C18.0486 14.3088 17.9355 14.5809 17.7531 14.7875C17.5918 14.9702 17.3923 15.1151 17.1687 15.2121C16.9159 15.3216 16.6222 15.3452 16.0348 15.3923L7.53999 16.0733C5.54223 16.2335 4.54335 16.3135 4.11115 16.7463C3.73611 17.1217 3.5632 17.6539 3.64592 18.1781C3.74124 18.7822 4.50227 19.4341 6.02435 20.7379L12.4965 26.282C12.944 26.6654 13.1678 26.8571 13.3079 27.0943C13.4319 27.3042 13.5081 27.5387 13.5312 27.7813C13.5572 28.0556 13.4889 28.3422 13.3522 28.9154L11.3748 37.2049C10.9098 39.1544 10.6773 40.1291 10.9552 40.6739C11.1964 41.1466 11.6491 41.4755 12.1732 41.5588C12.7772 41.6548 13.6324 41.1325 15.3428 40.0878L22.6155 35.6456C23.1184 35.3385 23.3699 35.1849 23.6388 35.125C23.8767 35.0719 24.1233 35.0719 24.3611 35.125C24.6301 35.1849 24.8815 35.3385 25.3844 35.6456L32.6572 40.0878C34.3675 41.1325 35.2227 41.6548 35.8267 41.5588C36.3508 41.4755 36.8035 41.1466 37.0447 40.6739C37.3227 40.1291 37.0902 39.1544 36.6251 37.2049L34.6478 28.9154C34.5111 28.3422 34.4427 28.0556 34.4688 27.7813C34.4919 27.5387 34.5681 27.3042 34.692 27.0943C34.8321 26.8571 35.0559 26.6654 35.5034 26.282L41.9756 20.7379C43.4977 19.4341 44.2587 18.7822 44.354 18.1781C44.4367 17.6539 44.2638 17.1217 43.8888 16.7463C43.4566 16.3135 42.4577 16.2335 40.46 16.0733L31.9651 15.3923C31.3778 15.3452 31.0841 15.3216 30.8312 15.2121C30.6076 15.1151 30.4081 14.9702 30.2468 14.7875C30.0645 14.5809 29.9513 14.3088 29.7251 13.7648L26.4523 5.89616C25.6827 4.04567 25.2978 3.12042 24.7527 2.84309C24.2797 2.60243 23.7202 2.60243 23.2472 2.84309Z"
        fill="var(--accent)"
      />
    </svg>
  );
};

const Stars = styled.div`
  display: flex;
  flex-grow: 0;
  flex-direction: row-reverse;
  cursor: pointer;
  flex-shrink: 1;
  width: 100%;
  justify-content: center;
  svg {
    width: auto;
    height: auto;
  }
  & > svg:hover,
  & > svg:hover ~ svg {
    path {
      fill: var(--accent);
    }
  }
`;
const TextRow = styled.div`
  display: flex;
  max-width: 375px;
  flex-direction: column;
  text-align: center;
  gap: 8px;
  ${Text.Body} {
    text-align: center;
  }
`;

const StyledCard = styled(Card)`
  display: flex;

  flex-direction: column;
  gap: 24px;
  padding: 32px;
  align-items: center;
  justify-content: center;
  text-align: center;
  @media (min-width: 1024px) {
    aspect-ratio: 512 / 360;
  }
`;

export const StarsRating = ({
  onSubmit,
}: {
  onSubmit: (value: number) => void;
}) => {
  return (
    <Stars>
      {[5, 4, 3, 2, 1].map((v) => (
        <Star
          key={v}
          onClick={() => {
            onSubmit(v);
          }}
        />
      ))}
    </Stars>
  );
};

export const SatisfactionSurvey = ({
  title,
  description,
  className,
  style,
  children,
}: {
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  title: string;
  description: string;
}) => {
  return (
    <StyledCard style={style} className={className}>
      <TextRow>
        <Text.H3>{title}</Text.H3>
        {description && <Text.Body secondary>{description}</Text.Body>}
      </TextRow>
      {children}
    </StyledCard>
  );
};
